/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectType } from './subjectType.model';
import { PaymentMethodCode } from './paymentMethodCode.model';
import { HouseNumberType } from './houseNumberType.model';


export interface ContactCreateDto { 
    account?: string;
    bankCode?: string;
    castObce?: string;
    cisloDomovni?: number;
    cisloOrientacni?: string;
    cpCe?: HouseNumberType;
    email?: string;
    iban?: string;
    ico?: string;
    jmeno?: string;
    mestskaCast?: string;
    nazev?: string;
    obec?: string;
    okres?: string;
    opsubType: SubjectType;
    paymentAddress: boolean;
    paymentMethod?: PaymentMethodCode;
    payoutRent: boolean;
    phone?: string;
    poznamka?: string;
    prijmeni?: string;
    psc?: string;
    rodneCislo?: string;
    specSym?: string;
    stat?: string;
    swift?: string;
    titulPredJmenem?: string;
    titulZaJmenem?: string;
    ulice?: string;
    varSym?: string;
    withdrawPostage: boolean;
}
export namespace ContactCreateDto {
}


